import React, { useEffect, useState } from 'react';
import RightSideBar from '../../components/RightSideBar/RightSideBar';
import { BiltyHomeCss as useStyles } from './BiltyCss';
import { SimTrackingIcon } from '../../../components/icons';
import {
    Grid
} from '@material-ui/core';
import { PrivacyApproval, NoteIcon, Floppy, FloppyDisk } from '../../../components/icons';
import LockIcon from '@material-ui/icons/Lock';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const BiltyHomeSteps = ({ open, onClose, onCreateBilty, user }) => {

    let submit;

    const classes = useStyles();

    const [dialogOpen, setDialogOpen] = useState(open);

    const handleCreateBilty = () => {
        onCreateBilty();
        setDialogOpen(false);
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }


    return (
        <>
            {dialogOpen && <RightSideBar
                sideBarName="online-bilty"
                rightSideBarOpen={dialogOpen}
                sideBarTitle={'Online Bilty'}
                sideBarType="biltyHomeSteps"
                fromBiltyFlow={true}
                handleSubmit={event => submit(event)}
                createBiltyClick={handleCreateBilty}
                toggleRightSideBar={handleClose}
                dividerNotRequired={true}
                fromBiltyHomeSteps={true}
            >

                <SimTrackingIcon className={classes.simTrackingIcon} />

                <div>
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        className={classes.gridV1}
                    >
                        <Grid
                            container
                            direction="row"
                        >
                            <div>
                                <NoteIcon className={classes.notesIcon} />
                            </div>
                            <div className={classes.divContent}>
                                <div className={classes.divStep}>Step 1</div>
                                <div className={classes.divStepName}>Company Details</div>
                                <div className={classes.divDetails}>You company address, contact & GST</div>
                                <div className={classes.divDetails1}>Number</div>
                            </div>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            className={classes.mtV1}
                        >
                            <div>
                                <Floppy className={classes.floppyIcon} />
                            </div>
                            <div className={classes.divContent}>
                                <div className={classes.divStep}>Step 2</div>
                                <div className={classes.divStepName}>Consignor & Consignee Details</div>
                                <div className={classes.divDetails}>Name, Address & GST details of consigner &</div>
                                <div className={classes.divDetails1}>consignee</div>
                            </div>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            className={classes.mtV1}
                        >
                            <div>
                                <FloppyDisk className={classes.floppyDiskIcon} />
                            </div>
                            <div className={classes.divContent}>
                                <div className={classes.divStep}>Step 3</div>
                                <div className={classes.divStepName}>Load & Trip Details</div>
                                <div className={classes.divDetails}>Add material details, freight amount, quantity</div>
                                <div className={classes.divDetails1}>and e-waybill</div>
                            </div>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            className={classes.mtV1}
                        >
                            <div>
                                <PrivacyApproval className={classes.privacyApprovalIcon} />
                            </div>
                            <div className={classes.divContent}>
                                <div className={classes.divStep}>Step 4</div>
                                <div className={classes.divStepName}>Insurance Details & Signature</div>
                                <div className={classes.divDetails}>Update Payment & Insurance  details to</div>
                                <div className={classes.divDetails1}>Download LR</div>
                            </div>
                        </Grid>
                    </Grid>


                    <div className={classes.divTerms}>
                        <div>We follow all privacy guidelines to protect your data with 100</div>
                        <div>% security. For more information, please contact us at</div>
                        <a href="mailto:hello@transportbook.in" className={classes.aV1}>hello@transportbook.in</a>
                        <div className={classes.divLock}>
                            <LockIcon className={classes.lockIcon} />
                            <div>100% Secure</div>
                            <FiberManualRecordIcon className={classes.iconV2} />
                            <div>256 -bit encryption</div>
                        </div>
                    </div>
                </div>

            </RightSideBar>}
        </>
    )

}

export default BiltyHomeSteps;